export default {
  "config": {
    "trial": "tones-3",
    "id": "wpai-actimp",
    "type": "design",
    "title": "Activity Impairment<sup>30</sup>",
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<no-break><sup>¶</sup><em>P</em> < 0.001</no-break> vs placebo. <em>P</em> values are uncontrolled for multiplicity; hence they are nominal. Values are for the mITT population (n = 459). Negative response from baseline denotes improvement."
    ],
    "useFootnoteTooltip": true
  },
  "data": {
    "trial": "tones-3",
    "id": "wpai-actimp",
    "data-type": "design",
    "title": "Activity Impairment<sup>30</sup>",
    "footnote-tooltip": "enable",
    "footnote-order": [
      "footnote-note1",
      "footnote-pvalue"
    ],
    "footnote-note1": "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
    "footnote-pvalue": "<no-break><sup>¶</sup><em>P</em> < 0.001</no-break> vs placebo. <em>P</em> values are uncontrolled for multiplicity; hence they are nominal. Values are for the mITT population (n = 459). Negative response from baseline denotes improvement."
  }
};